/* eslint-disable max-lines */

export const userUrls = [
  { user: 'Naval Research Laboratory', url: 'https://www.nrl.navy.mil/' },
  // { user: 'BSC', url: 'https://www.bsc.es/' },
  { user: 'NRL', url: 'https://www.nrl.navy.mil/' },
  { user: 'NASA', url: 'https://www.nasa.gov/' },
  { user: 'Bureau of Naval Weapons (BUWEPS)', url: 'https://www.navy.mil/' },
  { user: 'AFBMD', url: 'https://www.af.mil/' },
  { user: 'GSFC', url: 'https://www.nasa.gov/centers/goddard/home/index.html' },
  { user: 'LARCN', url: '' },
  { user: 'US Army / ARPA', url: 'https://www.army.mil/' },
  { user: 'Office of Naval Research / State University of Iowa', url: 'https://www.nrl.navy.mil/' },
  { user: 'AFSSD', url: '' },
  { user: 'BUWEPS', url: '' },
  { user: 'NASA Goddard Space Flight Center', url: 'https://www.nasa.gov/centers/goddard/home/index.html' },
  { user: 'Air Force Space Systems Division (AFSSD)', url: 'https://www.af.mil/' },
  { user: 'U.S. Navy', url: 'https://www.navy.mil/' },
  { user: 'ATT', url: 'https://www.att.com/' },
  { user: 'SAFSP', url: '' },
  { user: 'DRTE', url: '' },
  { user: 'LERC', url: '' },
  { user: 'NRO/NRL', url: 'https://www.nro.gov/' },
  { user: 'ACE/GIMR', url: '' },
  { user: 'NRO/SAFSP', url: '' },
  { user: 'OKB1', url: '' },
  { user: 'VNIEM', url: '' },
  { user: 'RVSN', url: '' },
  { user: 'OSCAR', url: 'https://airandspace.si.edu/collection-objects/communications-satellite-oscar-i/nasm_A19640011000' },
  { user: 'AFSSD/AEC', url: '' },
  { user: 'INTEL', url: '' },
  { user: 'AFSSD/MITLL', url: '' },
  { user: 'AFSD', url: '' },
  { user: 'ESSA', url: '' },
  { user: 'OKB10', url: '' },
  { user: 'OAR', url: '' },
  { user: 'CNES', url: '' },
  { user: 'ARC', url: '' },
  { user: 'NAVAIR', url: '' },
  { user: 'TSUKOS', url: '' },
  { user: 'SAMSO', url: '' },
  { user: 'ONR/RICE', url: '' },
  { user: 'TSKBM', url: '' },
  { user: 'CRC', url: '' },
  { user: 'PKO', url: '' },
  { user: 'PVO', url: '' },
  { user: 'MSFC', url: '' },
  { user: 'ARTOPL', url: '' },
  { user: 'DFVLR', url: '' },
  { user: 'MOD', url: '' },
  { user: 'MELB', url: '' },
  { user: 'NATO', url: '' },
  { user: 'JGB7', url: '' },
  { user: 'GUKOSR/GMS', url: '' },
  { user: 'TSKBEM', url: '' },
  { user: 'NOAA', url: '' },
  { user: 'ISAS', url: '' },
  { user: 'GUKOSR', url: '' },
  { user: 'OAR3', url: '' },
  { user: 'STP', url: '' },
  { user: 'USA/MITLL', url: '' },
  { user: 'RAE', url: '' },
  { user: 'SAMSO/DCA', url: '' },
  { user: 'YUZH/CNES', url: '' },
  { user: 'MSC', url: '' },
  { user: 'AMNA', url: '' },
  { user: 'TCAN', url: '' },
  { user: 'NRO/CIA', url: '' },
  { user: 'VMF', url: '' },
  { user: 'VTS', url: '' },
  { user: 'MOM/CNES', url: '' },
  { user: 'STP/ARPA', url: '' },
  { user: 'WUTC', url: '' },
  { user: 'PRIR', url: '' },
  { user: 'INTA', url: '' },
  { user: 'DFVLR/CNES', url: '' },
  { user: 'WFC', url: '' },
  { user: 'IKI/BABTS', url: '' },
  { user: 'NRO', url: '' },
  { user: 'CNES/DFVLR', url: '' },
  { user: 'NASDA', url: '' },
  { user: 'AMCR', url: '' },
  { user: 'COM', url: '' },
  { user: 'AMC', url: '' },
  { user: 'NICS', url: '' },
  { user: 'STP/APL', url: '' },
  { user: 'PER', url: '' },
  { user: 'MSVYAZ', url: '' },
  { user: 'ESA', url: '' },
  { user: 'SAMSO/USN', url: '' },
  { user: 'YUZH', url: '' },
  { user: 'NPOPM', url: '' },
  { user: 'CNR', url: '' },
  { user: 'NPOPM/MSVYAZ', url: '' },
  { user: 'GSFC/ESA', url: '' },
  { user: 'USNESC/SAMSO', url: '' },
  { user: 'USN', url: '' },
  { user: 'JPL', url: 'https://www.jpl.nasa.gov/' },
  { user: 'MAIO/MOM', url: '' },
  { user: 'MOM/VNIEM', url: '' },
  { user: 'STP/SAMSO', url: '' },
  { user: 'AFSD/DCA', url: '' },
  { user: 'USNESC/AFSD', url: '' },
  { user: 'SBS', url: '' },
  { user: 'GUKOS', url: '' },
  { user: 'GUKOS/GMS', url: '' },
  { user: 'ISRO', url: '' },
  { user: 'IK', url: '' },
  { user: 'GRU', url: '' },
  { user: 'NPOPM/MAIO', url: '' },
  { user: 'JPL/NIVR', url: '' },
  { user: 'AMDL', url: '' },
  { user: 'HCI', url: '' },
  { user: 'ATTS', url: '' },
  { user: 'GMS/YUZH', url: '' },
  { user: 'MAI', url: '' },
  { user: 'UOS', url: '' },
  { user: 'GTE', url: '' },
  { user: 'EUTEL', url: '' },
  { user: 'FTEL', url: '' },
  { user: 'AE', url: '' },
  { user: 'NPOE', url: '' },
  { user: 'TSN108', url: '' },
  { user: 'ARAB', url: '' },
  { user: 'EMBR', url: '' },
  { user: 'SCT', url: '' },
  { user: 'AUSS', url: '' },
  { user: 'CONT', url: '' },
  { user: 'GMS', url: '' },
  { user: 'GUKOS/MSVYAZ', url: '' },
  { user: 'AMCG', url: '' },
  { user: 'SSC', url: '' },
  { user: 'UNKS', url: '' },
  { user: 'UNKS/GMS', url: '' },
  { user: 'JARL', url: '' },
  { user: 'UNKS/MSVYAZ', url: '' },
  { user: 'MAI2', url: '' },
  { user: 'DBP', url: '' },
  { user: 'NASDA/TSCJ', url: '' },
  { user: 'CHIS', url: '' },
  { user: 'EUMET', url: '' },
  { user: 'PAN', url: '' },
  { user: 'NSMC', url: '' },
  { user: 'STLC', url: '' },
  { user: 'SES', url: '' },
  { user: 'JCSAT', url: '' },
  { user: 'NSAB', url: '' },
  { user: 'AFSSD2', url: '' },
  { user: 'SCC', url: '' },
  { user: 'VMF/UNKS', url: '' },
  { user: 'BSB', url: '' },
  { user: 'AFSSD2/DCA', url: '' },
  { user: 'SPAWAR', url: '' },
  { user: 'CSSR', url: '' },
  { user: 'MDAC', url: '' },
  { user: 'SSTL', url: '' },
  { user: 'AMBR', url: '' },
  { user: 'WEBC', url: '' },
  { user: 'AMLU', url: '' },
  { user: 'DARPA/USN', url: '' },
  { user: 'ASIA', url: '' },
  { user: 'AFSSD2/USN', url: '' },
  { user: 'DARPA', url: '' },
  { user: 'AFSSD2/MSFC', url: '' },
  { user: 'GDSSD', url: '' },
  { user: 'HCG', url: '' },
  { user: 'INMAR', url: '' },
  { user: 'ASI', url: '' },
  { user: 'MGON', url: '' },
  { user: 'UNKSR', url: '' },
  { user: 'VMF/UNKSR', url: '' },
  { user: 'UNKSR/MSVYAZ', url: '' },
  { user: 'CONTG', url: '' },
  { user: 'RGMS', url: '' },
  { user: 'RGMS/YUZH', url: '' },
  { user: 'GRUR', url: '' },
  { user: 'AFROM', url: '' },
  { user: 'ORBC', url: '' },
  { user: 'TUB', url: '' },
  { user: 'ESIE', url: '' },
  { user: 'RVSNR', url: '' },
  { user: 'CSFR', url: '' },
  { user: 'VVS', url: '' },
  { user: 'AFSSD2/DISA', url: '' },
  { user: 'VMFR', url: '' },
  { user: 'GPKS', url: '' },
  { user: 'TELK', url: '' },
  { user: 'VVSR', url: '' },
  { user: 'AFSMC/DISA', url: '' },
  { user: 'AFSMC', url: '' },
  { user: 'ISASS', url: '' },
  { user: 'JPL/CNES', url: '' },
  { user: 'KAIST', url: '' },
  { user: 'VKS', url: '' },
  { user: 'OPT', url: '' },
  { user: 'HSES', url: '' },
  { user: 'HISP', url: '' },
  { user: 'VKS/GPKS', url: '' },
  { user: 'VTSR', url: '' },
  { user: 'INPE', url: '' },
  { user: 'OSCC', url: '' },
  { user: 'STP/LANL', url: '' },
  { user: 'RACE', url: '' },
  { user: 'WSMC', url: '' },
  { user: 'VKS/RGMS', url: '' },
  { user: 'TSPZ', url: '' },
  { user: 'MSFC/OSCD', url: '' },
  { user: 'INFER', url: '' },
  { user: 'SATEL', url: '' },
  { user: 'AMIT', url: '' },
  { user: 'INETI', url: '' },
  { user: 'RIMSAT', url: '' },
  { user: 'TELMX', url: '' },
  { user: 'DTV/HCI', url: '' },
  { user: 'SHINW', url: '' },
  { user: 'INFK/LAND', url: '' },
  { user: 'BMDO', url: '' },
  { user: 'CASC1', url: '' },
  { user: 'DRA', url: '' },
  { user: 'NHK', url: '' },
  { user: 'VMFR/VKS', url: '' },
  { user: 'APT', url: '' },
  { user: 'TSSKB', url: '' },
  { user: 'TURKP', url: '' },
  { user: 'RGMS/YUZHUA', url: '' },
  { user: 'RGMS/VNIEMR', url: '' },
  { user: 'ORI', url: '' },
  { user: 'NPOPMR', url: '' },
  { user: 'FACS', url: '' },
  { user: 'MMA', url: '' },
  { user: 'ORBI', url: '' },
  { user: 'AMSC', url: '' },
  { user: 'PMW146', url: '' },
  { user: 'LMA', url: '' },
  { user: 'CNES/DGA', url: '' },
  { user: 'UPM', url: '' },
  { user: 'VKS/IACG', url: '' },
  { user: 'KTEL', url: '' },
  { user: 'CZ', url: '' },
  { user: 'JSAT', url: '' },
  { user: 'NTT', url: '' },
  { user: 'NKAU', url: '' },
  { user: 'CSA', url: '' },
  { user: 'ECHO', url: '' },
  { user: 'BINA', url: '' },
  { user: 'SINDO/PSN', url: '' },
  { user: 'GONETS', url: '' },
  { user: 'TMI', url: '' },
  { user: 'IAIS', url: '' },
  { user: 'NROC/NRL', url: '' },
  { user: 'TURKT', url: '' },
  { user: 'IKI/TSSKBP', url: '' },
  { user: 'UNAM', url: '' },
  { user: 'NAHU', url: '' },
  { user: 'TEMPO', url: '' },
  { user: 'BSAT', url: '' },
  { user: 'IRID', url: '' },
  { user: 'BOHB', url: '' },
  { user: 'TNOR', url: '' },
  { user: 'LSKY', url: '' },
  { user: 'NPOL', url: '' },
  { user: 'VKSR', url: '' },
  { user: 'MPSC', url: '' },
  { user: 'NROC/CIA', url: '' },
  { user: 'TSBM', url: '' },
  { user: 'INDO', url: '' },
  { user: 'MPE', url: '' },
  { user: 'EMBRM', url: '' },
  { user: 'GLOBT', url: '' },
  { user: 'NILE', url: '' },
  { user: 'CHORI', url: '' },
  { user: 'FACH', url: '' },
  { user: 'TMSAT', url: '' },
  { user: 'TECN', url: '' },
  { user: 'EOSAU', url: '' },
  { user: 'DLR2', url: '' },
  { user: 'SINO/EURAS', url: '' },
  { user: 'STEL', url: '' },
  { user: 'NROC', url: '' },
  { user: 'SEDSH', url: '' },
  { user: 'WORSP', url: '' },
  { user: 'USNPS', url: '' },
  { user: 'BONUM', url: '' },
  { user: 'SAMX', url: '' },
  { user: 'VMFR/VKSR', url: '' },
  { user: 'VKSR/IACG', url: '' },
  { user: 'SMCTV', url: '' },
  { user: 'DMI', url: '' },
  { user: 'STBO', url: '' },
  { user: 'BOSL', url: '' },
  { user: 'SEALC', url: '' },
  { user: 'USGS', url: '' },
  { user: 'KTRAS', url: '' },
  { user: 'LORI', url: '' },
  { user: 'CNSA', url: '' },
  { user: 'CECOM', url: '' },
  { user: 'VKSR/GPKS', url: '' },
  { user: 'GAZC', url: '' },
  { user: 'KHRR', url: '' },
  { user: 'SIMG', url: '' },
  { user: 'LMSCV/LMI', url: '' },
  { user: 'DTV', url: '' },
  { user: 'CAST/INPE', url: '' },
  { user: 'KARI', url: '' },
  { user: 'ZZB', url: '' },
  { user: 'WEB', url: '' },
  { user: 'STAN', url: '' },
  { user: 'USAFA', url: '' },
  { user: 'ASU', url: '' },
  { user: 'DARPA2', url: '' },
  { user: 'ACES', url: '' },
  { user: 'SCU', url: '' },
  { user: 'GPKS/ISPUT', url: '' },
  { user: 'STSM', url: '' },
  { user: 'EUROK', url: '' },
  { user: 'CASC', url: '' },
  { user: 'TSHUA', url: '' },
  { user: 'SIR', url: '' },
  { user: 'RKKE', url: '' },
  { user: 'BKSA', url: '' },
  { user: 'MEGS', url: '' },
  { user: 'ROGAU', url: '' },
  { user: 'KACST', url: '' },
  { user: 'AMCG/GECAP', url: '' },
  { user: 'THUR', url: '' },
  { user: 'EUPST', url: '' },
  { user: 'DERA', url: '' },
  { user: 'CONAE', url: '' },
  { user: 'IRF', url: '' },
  { user: 'EURSG/EURSA', url: '' },
  { user: 'PU', url: '' },
  { user: 'XMR', url: '' },
  { user: 'SEALP', url: '' },
  { user: 'KVR', url: '' },
  { user: 'SESGL', url: '' },
  { user: 'ICOH', url: '' },
  { user: 'INTELD', url: '' },
  { user: 'EUTSA', url: '' },
  { user: 'USNA/AFSMC', url: '' },
  { user: 'USNA/STAN', url: '' },
  { user: 'KVR/IACG', url: '' },
  { user: 'CNES/JPL', url: '' },
  { user: 'BLS', url: '' },
  { user: 'IZM/MAK', url: '' },
  { user: 'SUPA', url: '' },
  { user: 'CRTS', url: '' },
  { user: 'AFRL/NIIPP', url: '' },
  { user: 'University of Michigan', url: '' },
  { user: 'Chang Guang Satellite Technology Co.', url: '' },
  { user: 'SESA', url: '' },
  { user: 'NSS', url: '' },
  { user: 'GYZ/CASC', url: '' },
  { user: 'KS', url: '' },
  { user: 'NASA/APL', url: '' },
  { user: 'STELLT', url: '' },
  { user: 'NTTDM', url: '' },
  { user: 'VMFR/KVR', url: '' },
  { user: 'ASAL', url: '' },
  { user: 'MOZHA', url: '' },
  { user: 'CRCSS', url: '' },
  { user: 'CHIBA', url: '' },
  { user: 'OHB', url: '' },
  { user: 'APRZ', url: '' },
  { user: 'TRORB', url: '' },
  { user: 'HELSA', url: '' },
  { user: 'AMCS', url: '' },
  { user: 'OPTS', url: '' },
  { user: 'DTU', url: '' },
  { user: 'TIT', url: '' },
  { user: 'QUAFI', url: '' },
  { user: 'AAU', url: '' },
  { user: 'UTIAS', url: '' },
  { user: 'TOK', url: '' },
  { user: 'RBOW', url: '' },
  { user: 'LMSSD', url: '' },
  { user: 'NSRDA', url: '' },
  { user: 'BNSC', url: '' },
  { user: 'TUBTK', url: '' },
  { user: 'NIIKP', url: '' },
  { user: 'KAIST/KARI', url: '' },
  { user: 'ZZWYZ/INPE', url: '' },
  { user: 'CAST', url: '' },
  { user: 'USEF', url: '' },
  { user: 'LSKYB', url: '' },
  { user: 'MBCO/TUMED', url: '' },
  { user: 'NSPT', url: '' },
  { user: 'LOR', url: '' },
  { user: 'SPQ', url: '' },
  { user: 'HISPM/HISP', url: '' },
  { user: 'MGU/KVR', url: '' },
  { user: 'XTAR', url: '' },
  { user: 'JAXA', url: '' },
  { user: 'INMRL', url: '' },
  { user: 'AMVU', url: '' },
  { user: 'SHIN', url: '' },
  { user: 'ISASJ', url: '' },
  { user: 'DGA', url: '' },
  { user: 'BLMIT', url: '' },
  { user: 'WURZ', url: '' },
  { user: 'IROST/ITRC', url: '' },
  { user: 'NSC/ARR', url: '' },
  { user: 'JCAB/JMA', url: '' },
  { user: 'HISD', url: '' },
  { user: 'RCA', url: '' },
  { user: 'NSPO', url: '' },
  { user: 'IMAGT', url: '' },
  { user: 'TSSKBP', url: '' },
  { user: 'KAZK', url: '' },
  { user: 'BIGEL', url: '' },
  { user: 'KTELT/ADD', url: '' },
  { user: 'SINO', url: '' },
  { user: 'WBLU', url: '' },
  { user: 'SESSL/SESG', url: '' },
  { user: 'MEAS', url: '' },
  { user: 'MHI', url: '' },
  { user: 'LAPAN', url: '' },
  { user: 'PARA', url: '' },
  { user: 'NARSS', url: '' },
  { user: 'TUI', url: '' },
  { user: 'USERAR', url: '' },
  { user: 'CALP', url: '' },
  { user: 'ULLAF', url: '' },
  { user: 'AERO', url: '' },
  { user: 'SESSA', url: '' },
  { user: 'NGCOM', url: '' },
  { user: 'GLOB', url: '' },
  { user: 'DLR2/EASF', url: '' },
  { user: 'ULAL', url: '' },
  { user: 'CHISA', url: '' },
  { user: 'HNS', url: '' },
  { user: 'DGLO', url: '' },
  { user: 'BWB', url: '' },
  { user: 'ULAB', url: '' },
  { user: 'STONE', url: '' },
  { user: 'SESS', url: '' },
  { user: 'I-RASC/RSQ', url: '' },
  { user: 'HORZ', url: '' },
  { user: 'ICONA', url: '' },
  { user: 'VNPT', url: '' },
  { user: 'UTIAS/COMDEV', url: '' },
  { user: 'AACH', url: '' },
  { user: 'NIHON', url: '' },
  { user: 'RESH/ROSTO', url: '' },
  { user: 'TURKS', url: '' },
  { user: 'PROTO', url: '' },
  { user: 'DISH', url: '' },
  { user: 'SCCJ', url: '' },
  { user: 'REYE', url: '' },
  { user: 'ZZWYZ', url: '' },
  { user: 'GEYE', url: '' },
  { user: 'TCANL', url: '' },
  { user: 'SPX', url: 'https://www.spacex.com/' },
  { user: 'GISTDA', url: '' },
  { user: 'ABAE', url: '' },
  { user: 'CIEL', url: '' },
  { user: 'TOHO', url: '' },
  { user: 'SORUN', url: '' },
  { user: 'SOHLA/JAXA', url: '' },
  { user: 'KAGA', url: '' },
  { user: 'KOUKO', url: '' },
  { user: 'IKI/VNIEMR', url: '' },
  { user: 'SESSL/SESNS', url: '' },
  { user: 'IRIDS', url: '' },
  { user: 'TSKY', url: '' },
  { user: 'SIS', url: '' },
  { user: 'SIRX', url: '' },
  { user: 'TERRE', url: '' },
  { user: 'BKSA/ATSB', url: '' },
  { user: 'POLK', url: '' },
  { user: 'DEIMOS', url: '' },
  { user: 'EIAST', url: '' },
  { user: 'SSTLA/DMC', url: '' },
  { user: 'SKPJ', url: '' },
  { user: 'INDOS', url: '' },
  { user: 'MGU/VNIEMR', url: '' },
  { user: 'UGATU', url: '' },
  { user: 'NIIPP', url: '' },
  { user: 'EPFL', url: '' },
  { user: 'ITUTR', url: '' },
  { user: 'ITBW', url: '' },
  { user: 'SESSL', url: '' },
  { user: 'CAMSAT', url: '' },
  { user: 'INTELU', url: '' },
  { user: 'NMIT', url: '' },
  { user: 'NSC', url: '' },
  { user: 'SUPSI', url: '' },
  { user: 'AFMCSW', url: '' },
  { user: 'GCDX', url: '' },
  { user: 'CHISAE', url: '' },
  { user: 'JAXA/SPAC', url: '' },
  { user: 'ZHEJ', url: '' },
  { user: 'SKYTE', url: '' },
  { user: 'UMI/NSF', url: '' },
  { user: 'AVANTI', url: '' },
  { user: 'KTELT', url: '' },
  { user: 'RGMS/NPOL', url: '' },
  { user: 'NTU', url: '' },
  { user: 'NDAWN', url: '' },
  { user: 'ALYAH', url: '' },
  { user: 'AFSPC', url: '' },
  { user: 'TSKYBR', url: '' },
  { user: 'ST2V/STEL', url: '' },
  { user: 'GLOBL', url: '' },
  { user: 'BABTS/FIAN', url: '' },
  { user: 'SESE/SESSA', url: '' },
  { user: 'SESSAP', url: '' },
  { user: 'ASI/GAUSS', url: '' },
  { user: 'TUBTU', url: '' },
  { user: 'DKAU', url: '' },
  { user: 'ELUS', url: '' },
  { user: 'IITK', url: '' },
  { user: 'LUXS/ORBC', url: '' },
  { user: 'SRMU', url: '' },
  { user: 'VIA', url: '' },
  { user: 'ESA/GSAEU', url: '' },
  { user: 'GSFC/NOAA', url: '' },
  { user: 'RESH', url: '' },
  { user: 'GCDX/ZZWYZ', url: '' },
  { user: 'SPAWSD', url: '' },
  { user: 'KYUT', url: '' },
  { user: 'GSFC/JPL', url: '' },
  { user: 'VVKO', url: '' },
  { user: 'EHNS', url: '' },
  { user: 'SESS/SESSAN', url: '' },
  { user: 'EXEA', url: '' },
  { user: 'NPOL/IKI', url: '' },
  { user: 'GSFC/APL', url: '' },
  { user: 'SPOT', url: '' },
  { user: 'OIT', url: '' },
  { user: 'SMDC', url: '' },
  { user: 'UCO', url: '' },
  { user: 'MSUKY', url: '' },
  { user: 'UCB', url: '' },
  { user: 'LLNL', url: '' },
  { user: 'NROC/CALP', url: '' },
  { user: 'GAZS', url: '' },
  { user: 'ECHOC', url: '' },
  { user: 'KCST', url: '' },
  { user: 'MSBTR', url: '' },
  { user: 'AEMX', url: '' },
  { user: 'AZER', url: '' },
  { user: 'ISRO/CNES', url: '' },
  { user: 'DRDC/DND', url: '' },
  { user: 'SSTLA/SURREY', url: '' },
  { user: 'TUG', url: '' },
  { user: 'UVIE/UTIAS', url: '' },
  { user: 'VNIIEMI', url: '' },
  { user: 'COSMOG', url: '' },
  { user: 'SGAU', url: '' },
  { user: 'CNSAS', url: '' },
  { user: 'EXA', url: '' },
  { user: 'MINCYT', url: '' },
  { user: 'VVKO/IACG', url: '' },
  { user: 'VAST', url: '' },
  { user: 'ESSP', url: '' },
  { user: 'O3B', url: '' },
  { user: 'NPOMA', url: '' },
  { user: 'ARC/GSFC', url: '' },
  { user: 'SECM', url: '' },
  { user: 'INMRL/ESA', url: '' },
  { user: 'ESHAIL/EUTSA', url: '' },
  { user: 'INAVC/ISRO', url: '' },
  { user: 'CORN', url: '' },
  { user: 'POPACS', url: '' },
  { user: 'CPUT', url: '' },
  { user: 'SKYBOX', url: '' },
  { user: 'GAUSS', url: '' },
  { user: 'WNI', url: '' },
  { user: 'KHUS', url: '' },
  { user: 'ISISBV', url: '' },
  { user: 'DELFT', url: '' },
  { user: 'PLABS', url: '' },
  { user: 'GOMSP', url: '' },
  { user: 'CBKPL', url: '' },
  { user: 'ISTPK', url: '' },
  { user: 'VIGO', url: '' },
  { user: 'STADK', url: '' },
  { user: 'TUM', url: '' },
  { user: 'PUCP', url: '' },
  { user: 'AMNL/AMUK', url: '' },
  { user: 'HIN', url: '' },
  { user: 'AFIT', url: '' },
  { user: 'UMI/JPL', url: '' },
  { user: 'CUNYME', url: '' },
  { user: 'CALP/JPL', url: '' },
  { user: 'ABE', url: '' },
  { user: 'TSKHM', url: '' },
  { user: 'THAIC', url: '' },
  { user: 'ABSHK', url: '' },
  { user: 'CNES/ASI', url: '' },
  { user: 'KHRO', url: '' },
  { user: 'NPOLO', url: '' },
  { user: 'MOMR', url: '' },
  { user: 'WAKA', url: '' },
  { user: 'KASH', url: '' },
  { user: 'ELDEC', url: '' },
  { user: 'SATELOG', url: '' },
  { user: 'SPUT', url: '' },
  { user: 'CSA/UTIAS', url: '' },
  { user: 'HSCIL', url: '' },
  { user: 'VKI/NCKU', url: '' },
  { user: 'INPES/UFSM', url: '' },
  { user: 'QB50', url: '' },
  { user: 'MICSG', url: '' },
  { user: 'FING/ANTEL', url: '' },
  { user: 'CANOP', url: '' },
  { user: 'KPI', url: '' },
  { user: 'ROSAP/IQMOST', url: '' },
  { user: 'NANSFI', url: '' },
  { user: 'RGMS/VNIIEMI', url: '' },
  { user: 'NPOLO/IKI', url: '' },
  { user: 'DAUR', url: '' },
  { user: 'DND', url: '' },
  { user: 'UKSA', url: '' },
  { user: 'UKTSB', url: '' },
  { user: 'AFRL', url: '' },
  { user: 'GSAEU', url: '' },
  { user: 'FSB', url: '' },
  { user: 'JMA', url: '' },
  { user: 'INTELU/DTV', url: '' },
  { user: 'ARSAT', url: '' },
  { user: 'JSS', url: '' },
  { user: 'AXEL/TOK', url: '' },
  { user: 'VVKOV', url: '' },
  { user: 'AGSL', url: '' },
  { user: 'EUTAM', url: '' },
  { user: 'Russian Ministry of Defense', url: '' },
  { user: 'SSIM/TMTEL', url: '' },
  { user: 'DTVA', url: '' },
  { user: 'SKYM/DTVLA', url: '' },
  { user: 'COPERN/ESA', url: '' },
  { user: 'DMC', url: '' },
  { user: 'SSTLA', url: '' },
  { user: 'SURREY', url: '' },
  { user: 'NUDTC', url: '' },
  { user: 'HARB', url: '' },
  { user: 'SPIRE', url: '' },
  { user: 'NBN', url: '' },
  { user: 'CGSTL', url: '' },
  { user: 'SKC', url: '' },
  { user: 'UAF', url: '' },
  { user: 'SRII', url: '' },
  { user: 'LANAST/APMT', url: '' },
  { user: 'RGMS/NPOLO', url: '' },
  { user: 'NUS', url: '' },
  { user: 'AGILS', url: '' },
  { user: 'CAS', url: '' },
  { user: 'ZTZM', url: '' },
  { user: 'CNES/NOAA', url: '' },
  { user: 'VVKOV/IACG', url: '' },
  { user: 'JAXA/ISASJ', url: '' },
  { user: 'NAG', url: '' },
  { user: 'NAG/MHIME', url: '' },
  { user: 'ZLZB', url: '' },
  { user: 'TSVS', url: '' },
  { user: 'INTELU/DTVLA', url: '' },
  { user: 'BRID', url: '' },
  { user: 'TBELLA', url: '' },
  { user: 'DND/EXEA', url: '' },
  { user: 'GWHYZ', url: '' },
  { user: 'MDPE', url: '' },
  { user: 'IITB', url: '' },
  { user: 'PESU', url: '' },
  { user: 'BSKG', url: '' },
  { user: 'ASAL/UKSA', url: '' },
  { user: 'CHISAE/CAST', url: '' },
  { user: 'KCHT', url: '' },
  { user: 'APL/GSFC', url: '' },
  { user: 'AFRL/CALP', url: '' },
  { user: 'SOCOM', url: '' },
  { user: 'SAST', url: '' },
  { user: 'LARCN/SWRIB', url: '' },
  { user: 'OATKC', url: '' },
  { user: 'SECM/NSMC', url: '' },
  { user: 'CATON', url: '' },
  { user: 'DTVLA/INTELU', url: '' },
  { user: 'KTSAT', url: '' },
  { user: 'TELB2', url: '' },
  { user: 'AESP', url: '' },
  { user: 'NUSS/JAXA', url: '' },
  { user: 'ECHOM', url: '' },
  { user: 'ZHUORB', url: '' },
  { user: 'URUGUS', url: '' },
  { user: 'CANON', url: '' },
  { user: 'DORBIT', url: '' },
  { user: 'BGSAT', url: '' },
  { user: 'HELSAR', url: '' },
  { user: 'STATS', url: '' },
  { user: 'MAIO', url: '' },
  { user: 'IRSS', url: '' },
  { user: 'YUZGU/UTE', url: '' },
  { user: 'ROSK', url: '' },
  { user: 'GEOOPT', url: '' },
  { user: 'TYVAK', url: '' },
  { user: 'ADIG', url: '' },
  { user: 'ISA/CNES', url: '' },
  { user: 'VVKOV/VOENT', url: '' },
  { user: 'AFORS', url: '' },
  { user: 'PLABST', url: '' },
  { user: 'RMAF', url: '' },
  { user: 'HEAD', url: '' },
  { user: 'FUDAN', url: '' },
  { user: 'MIT/MITLL', url: '' },
  { user: 'NWNAZ', url: '' },
  { user: 'AMNA/VANDU', url: '' },
  { user: 'ERAU', url: '' },
  { user: 'ZLZB/GCDX', url: '' },
  { user: 'GGPEN', url: '' },
  { user: 'BHSJ', url: '' },
  { user: 'EARI/UKSPOC', url: '' },
  { user: 'CGSTZ/CGSTL', url: '' },
  { user: 'WEINA', url: '' },
  { user: 'YAHBR', url: '' },
  { user: 'O3BS', url: '' },
  { user: 'DSNC', url: '' },
  { user: 'BCSCL', url: '' },
  { user: 'CASC/HARB', url: '' },
  { user: 'JPL/GFZ', url: '' },
  { user: 'WUHAN', url: '' },
  { user: 'CENTI', url: '' },
  { user: 'ALIEX', url: '' },
  { user: 'GZZB/CNES', url: '' },
  { user: 'LFLT', url: '' },
  { user: 'MBRSC', url: '' },
  { user: 'DOST/UPD', url: '' },
  { user: 'SHIZ', url: '' },
  { user: 'AUT', url: '' },
  { user: 'ESHAIL', url: '' },
  { user: 'ISCAS', url: '' },
  { user: 'GUOX', url: '' },
  { user: 'CLASP', url: '' },
  { user: 'SIRION/HELW', url: '' },
  { user: 'WEISS', url: '' },
  { user: 'SFLIN', url: '' },
  { user: 'USCGR/DHSST', url: '' },
  { user: 'HE360', url: '' },
  { user: 'AISTS', url: '' },
  { user: 'PLAN', url: '' },
  { user: 'NVART', url: '' },
  { user: 'GIT', url: '' },
  { user: 'HIBER', url: '' },
  { user: 'EXSEED', url: '' },
  { user: 'RAAF', url: '' },
  { user: 'HONEYA/UKSA', url: '' },
  { user: 'SNU', url: '' },
  { user: 'GHALAM', url: '' },
  { user: 'ITA', url: '' },
  { user: 'IPSF', url: '' },
  { user: 'OHBI', url: '' },
  { user: 'AUINS/SPQ', url: '' },
  { user: 'ACAST', url: '' },
  { user: 'ICEYE', url: '' },
  { user: 'JUST', url: '' },
  { user: 'AALTO', url: '' },
  { user: 'KAZNU', url: '' },
  { user: 'KMUTNB', url: '' },
  { user: 'FLEET', url: '' },
  { user: 'AUDACY', url: '' },
  { user: 'MYRI/SPQ', url: '' },
  { user: 'SWARM', url: '' },
  { user: 'UNCW/MOOREF', url: '' },
  { user: 'KRAU', url: '' },
  { user: 'UESTC/GUOX', url: '' },
  { user: 'CASIC', url: '' },
  { user: 'ISKY', url: '' },
  { user: 'GOS', url: '' },
  { user: 'SPIREL', url: '' },
  { user: 'AXEL', url: '' },
  { user: 'DFHYT', url: '' },
  { user: 'HXKJ/CGSTL', url: '' },
  { user: 'HELSAR/KACST', url: '' },
  { user: 'EGYSA', url: '' },
  { user: 'PSN', url: '' },
  { user: 'ONEWEB', url: 'https://www.oneweb.world/' },
  { user: 'DKJ', url: '' },
  { user: 'TZJ/GUOG', url: '' },
  { user: 'CTYK', url: '' },
  { user: 'GACO', url: '' },
  { user: 'UTE', url: '' },
  { user: 'MOMENT', url: '' },
  { user: 'EXOL', url: '' },
  { user: 'QIANC', url: '' },
  { user: 'GUOG', url: '' },
  { user: 'UNSEEN', url: '' },
  { user: 'CNSSC', url: '' },
  { user: 'BNU', url: '' },
  { user: 'ASES', url: '' },
  { user: 'SPLOG', url: '' },
  { user: 'NGISC', url: '' },
  { user: 'RLABN', url: '' },
  { user: 'SPXS', url: 'https://www.spacex.com/' },
  { user: 'NINGX/CASC', url: '' },
  { user: 'KLEO/YUANX', url: '' },
  { user: 'HERA', url: '' },
  { user: 'SKPJ/KACBS', url: '' },
  { user: 'MDDI/ASI', url: '' },
  { user: 'BDSAGR/XZTIA', url: '' },
  { user: 'ESSTI', url: '' },
  { user: 'ZHONG', url: '' },
  { user: 'DEYA/NUDTC', url: '' },
  { user: 'UFSC', url: '' },
  { user: 'TLCJ/ZXKJ', url: '' },
  { user: 'TLCJ/GUOX', url: '' },
  { user: 'SNIU', url: '' },
  { user: 'YINHE', url: '' },
  { user: 'XYUN', url: '' },
  { user: 'BU', url: '' },
  { user: 'RAAF/UNSW', url: '' },
  { user: 'SMC', url: '' },
  { user: 'APTS', url: '' },
  { user: 'ADD/DAPA', url: '' },
  { user: 'PLANQ', url: '' },
  { user: 'ECHOAU', url: '' },
  { user: 'PNTV', url: '' },
  { user: 'SPSI', url: '' },
  { user: 'GHG', url: '' },
  { user: 'SPHARM', url: '' },
  { user: 'UPC', url: '' },
  { user: 'OSM/GEOOPT', url: '' },
  { user: 'RTAF', url: '' },
  { user: 'AURAK/MASDAR', url: '' },
  { user: 'BAUM', url: '' },
  { user: 'MGU', url: '' },
  { user: 'NOVSU', url: '' },
  { user: 'KEPLER', url: '' },
  { user: 'ZFT', url: '' },
  { user: 'YWZB', url: '' },
  { user: 'KLEOS', url: '' },
  { user: 'NANAV', url: '' },
  { user: 'TSEPT', url: '' },
  { user: 'LDSE/SAST', url: '' },
  { user: 'CSICE', url: '' },
  { user: 'UAEAF', url: '' },
  { user: 'MORF', url: '' },
  { user: 'OHB/YUANX', url: '' },
  { user: 'R2SP/OFX', url: '' },
  { user: 'ISRO/NSIL', url: '' },
  { user: 'AXEL/FUKUI', url: '' },
  { user: 'YONS', url: '' },
  { user: 'ROSAP/NAIR', url: '' },
  { user: 'ASTSC', url: '' },
  { user: 'GKLS', url: '' },
  { user: 'VSHE/SIROTS', url: '' },
  { user: 'VSHE', url: '' },
  { user: 'KSU', url: '' },
  { user: 'TELTN', url: '' },
  { user: 'CHOSU', url: '' },
  { user: 'TUKE', url: '' },
  { user: 'UNSW/RAAF', url: '' },
  { user: 'SMDC/TSEPT', url: '' },
  { user: 'ONEWEBN', url: 'https://www.oneweb.world/' },
  { user: 'ADSTI', url: '' },
  { user: 'AUINS/NANAV', url: '' },
  { user: 'TYVI/EUTSA', url: '' },
  { user: 'CMSEO', url: '' },
  { user: 'TYVAK/LLNL', url: '' },
  { user: 'USSF', url: '' },
  { user: '21AT', url: '' },
  { user: 'RNAF', url: '' },
  { user: 'SDA/GACO', url: '' },
  { user: 'SDA/DARPA2', url: '' },
  { user: 'LOFT', url: '' },
  { user: 'INSPM', url: '' },
  { user: 'ADIG/OFAB', url: '' },
  { user: 'ASPLB', url: '' },
  { user: 'ADIG/ORBSK', url: '' },
  { user: 'ENDUR', url: '' },
  { user: 'REAKT', url: '' },
  { user: 'ROSAP', url: '' },
  { user: 'USGS/GSFC', url: '' },
  { user: 'CESIUM', url: '' },
  { user: 'NJU/SAST', url: '' },
  { user: 'HUOYAN', url: '' },
  { user: 'SISE', url: '' },
  { user: 'APSCO/BUAA', url: '' },
  { user: 'GSFC/SWRI', url: '' },
  { user: 'TEIK', url: '' },
  { user: 'VNSC/MEISEI', url: '' },
  { user: 'MHIME', url: '' },
  { user: 'KAWA', url: '' },
  { user: 'KOCHI', url: '' },
  { user: 'AOGD', url: '' },
  { user: 'EUSPA', url: '' },
  { user: 'SpaceX', url: 'https://www.spacex.com/' },
  { user: 'NCKU', url: '' },
  { user: 'NTNU', url: '' },
  { user: 'SEN', url: '' },
  { user: 'LUNASD', url: '' },
  { user: 'ICEUS', url: '' },
  { user: 'VZLU', url: '' },
  { user: 'ASTSC/SSTLA', url: '' },
  { user: 'IISTT', url: '' },
  { user: 'SANYZ', url: '' },
  { user: 'SILUTT', url: '' },
  { user: 'TIANDI', url: '' },
  { user: 'SYNSP', url: '' },
  { user: 'IRGC', url: '' },
  { user: 'SFSSC', url: '' },
  { user: 'CHFEN', url: '' },
  { user: 'ZJUNI', url: '' },
  { user: 'OMNISP', url: '' },
  { user: 'NDRE', url: '' },
  { user: 'LYNK', url: '' },
  { user: 'SIWEI', url: '' },
  { user: 'PLNSST', url: '' },
  { user: 'FAB/ICEYE', url: '' },
  { user: 'SPIND', url: '' },
  { user: 'ICEYE/ICEUS', url: '' },
  { user: 'STIOT', url: 'https://sateliot.space/' },
  { user: 'Sateliot', url: 'https://sateliot.space/' },
  { user: 'GEOAM', url: '' },
  { user: 'VARI', url: '' },
  { user: 'GEESP', url: '' },
  { user: 'NSIL', url: '' },
  { user: 'ADVSP/ARC', url: '' },
  { user: 'DSTA/STELEC', url: '' },
  { user: 'ULAD', url: '' },
  { user: 'ENEA/UNF2', url: '' },
  { user: 'UMARB', url: '' },
  { user: 'ARCAD', url: '' },
  { user: 'MONTP/CERN', url: '' },
  { user: 'MONTP', url: '' },
  { user: 'NANYUE', url: '' },
  { user: 'CALT', url: '' },
  { user: 'IRSA/BDS', url: '' },
  { user: 'IMICAS', url: '' },
  { user: 'GRC', url: '' },
  { user: 'BOHB/SFLIN', url: '' },
  { user: 'ASTS', url: '' },
  { user: 'NSIL/ISRO', url: '' },
  { user: 'RAKA', url: '' },
  { user: 'SNSB', url: '' },
  { user: 'AFRCO', url: '' },
  { user: 'EXPACE', url: '' },
  { user: 'CGSTL/MEIHUA', url: '' },
  { user: 'HKATG', url: '' },
  { user: 'SCANW', url: '' },
  { user: 'OCOSB/IEEC', url: '' },
  { user: 'NLR/NDRE', url: '' },
  { user: 'UMBRA', url: '' },
  { user: 'SKYKR', url: '' },
  { user: 'EOSDA', url: '' },
  { user: 'SONY', url: '' },
  { user: 'TAU', url: '' },
  { user: 'NANAV/GAMA', url: '' },
  { user: 'EPICU/EPIC', url: '' },
  { user: 'KWU', url: '' },
  { user: 'SHARJ', url: '' },
  { user: 'CLAAC', url: '' },
  { user: 'XIAMT/ZXHK', url: '' },
  { user: 'TIANMU', url: '' },
  { user: 'SFSSC/MILLES', url: '' },
  { user: 'CAPSP', url: '' },
  { user: 'PIESAT', url: '' },
  { user: 'SDA', url: '' },
  { user: 'ORBAS/AFORGE', url: '' },
  { user: 'DEWA', url: '' },
  { user: 'STIOT', url: '' },
  { user: 'TRPT', url: '' },
  { user: 'ORBSK', url: '' },
  { user: 'TOMIO', url: '' },
  { user: 'EMAVI', url: '' },
  { user: 'KESA/SAYARI', url: '' },
  { user: 'CLAAC/WYV', url: '' },
  { user: 'OUTP', url: '' },
  { user: 'ARIU', url: '' },
  { user: 'ASTRAN', url: '' },
  { user: 'GRSP', url: '' },
  { user: 'MITLL', url: '' },
  { user: 'KASI', url: '' },
  { user: 'KAIRSP', url: '' },
  { user: 'JUSTEK', url: '' },
  { user: 'LUMIR', url: '' },
  { user: 'FUCHW', url: '' },
  { user: 'STFISH', url: '' },
  { user: 'SATLAN', url: '' },
  { user: 'OQT', url: '' },
  { user: 'AFRL/VIA', url: '' },
  { user: 'IMAG/FACH', url: '' },
  { user: 'SATVU', url: '' },
  { user: 'LAUN', url: '' },
  { user: 'AZBST', url: '' },
  { user: 'TURION', url: '' },
  { user: 'SPIRE/ORORA', url: '' },
  { user: 'TORP/VATC', url: '' },
  { user: 'CGSTL/XHT', url: '' },
  { user: 'CGSTL/GHK', url: '' },
  { user: 'CGSTL/HXK', url: '' },
  { user: 'PSNT', url: '' },
  { user: 'DFHZ', url: '' },
  { user: 'STRAT', url: '' },
  { user: 'SIBGAU', url: '' },
  { user: 'B1440', url: '' },
  { user: 'S29POD', url: '' },
  { user: 'QSP/MISIS', url: '' },
  { user: 'KGTU', url: '' },
  { user: 'BSUBY', url: '' },
  { user: 'SITRO', url: '' },
  { user: 'CHGU', url: '' },
  { user: 'BGOPT', url: '' },
  { user: 'STTS', url: '' },
  { user: 'VIZ/NISYS', url: '' },
  { user: 'OGU', url: '' },
  { user: 'SPBPU', url: '' },
  { user: 'ANGKX', url: '' },
  { user: 'UTMN', url: '' },
  { user: 'FIRON', url: '' },
  { user: 'DLR', url: '' },
  { user: 'KUZGTU', url: '' },
  { user: 'STRAT/MKS', url: '' },
  { user: 'SBSZ', url: '' },
  { user: 'SXAK/CUMT', url: '' },
  { user: 'SXAK', url: '' },
  { user: 'SXAK/ZDNC', url: '' },
  { user: 'EHNS/ECHOC', url: '' },
  { user: 'ALIENA', url: '' },
  { user: 'Nanyang Technological University (NTU)', url: '' },
  { user: 'HORZ/INTELU', url: '' },
  { user: 'ZXHK', url: '' },
  { user: 'TYSK', url: '' },
  { user: 'STARV/HENAN', url: '' },
  { user: 'XHT', url: '' },
  { user: 'KUIP', url: '' },
  { user: 'TASA', url: '' },
  { user: 'OCOS/ESA', url: '' },
  { user: 'ORBAS', url: '' },
  { user: 'SPIREG/GHG', url: '' },
  { user: 'TUKE/SPMNC', url: '' },
  { user: 'OCOSB/ANDU', url: '' },
  { user: 'FOXC', url: '' },
  { user: 'CERD/MONTP', url: '' },
  { user: 'GENMAT', url: '' },
  { user: 'APOGEO', url: '' },
  { user: 'EXOTR', url: '' },
  { user: 'IMPUL', url: '' },
  { user: 'KAFA', url: '' },
  { user: 'PROM', url: '' },
  { user: 'NARAST', url: '' },
  { user: 'ROGUE', url: '' },
  { user: 'RIKEN/MITSUI', url: '' },
  { user: 'KP', url: '' },
  { user: 'DAPA', url: '' },
  { user: 'KANA', url: '' },
  { user: 'YORKSS', url: '' },
  { user: 'SITAEL', url: '' },
  { user: 'UNISTW/NCKU', url: '' },
  { user: 'BAZMQ', url: '' },
  { user: 'UCDB', url: '' },
  { user: 'HANWHA', url: '' },
  { user: 'ADD', url: '' },
  { user: 'ZHK/TLCJ', url: '' },
  { user: 'CZHJ', url: '' },
  { user: 'CTYK/HNUST', url: '' },
  { user: 'HONGQ', url: '' },
  { user: 'IAC', url: '' },
  { user: 'KPL', url: '' },
  { user: 'ITTANK', url: '' },
  { user: 'SPCIN', url: '' },
  { user: 'QPS', url: '' },
  { user: 'ZZB/CAST', url: '' },
  { user: 'ZYK', url: '' },
  { user: 'INNO', url: '' },
  { user: 'ODYSS', url: '' },
  { user: 'SPIREG', url: '' },
  { user: 'OVZON', url: '' },
  { user: 'ALBAD', url: '' },
  { user: 'CASIOM', url: '' },
  { user: 'YYAO', url: '' },
  { user: 'IRSA', url: '' },
  { user: 'SPIRE/NSTAR', url: '' },
  { user: 'WEIJT', url: '' },
  { user: 'LUHAI/DFHG', url: '' },
  { user: 'ZHIXJ', url: '' },
  { user: 'MDA', url: '' },
  { user: 'CLAAC/AACCS', url: '' },
  { user: 'MUON', url: '' },
  { user: 'METHS', url: '' },
  { user: 'SFSSC/ORISS', url: '' },
  { user: 'SATORO/NCKU', url: '' },
  { user: 'NIWCP', url: '' },
  { user: 'CAREWX', url: '' },
  { user: 'CONTEC', url: '' },
  { user: 'SPMACH', url: '' },
  { user: 'TANOM', url: '' },
  { user: 'APEX', url: '' },
  { user: 'ATOMOS', url: '' },
  { user: 'SIDUS', url: '' },
  { user: 'QUSP', url: '' },
  { user: 'ONDO', url: '' },
  { user: 'CEIIA/EDISF', url: '' },
  { user: 'SPIREG/HUBN', url: '' },
  { user: 'OCOS', url: '' },
  { user: 'CASC/CSUCAS', url: '' },
  { user: 'TASL', url: '' },
  { user: 'CRYPTO', url: '' },
  { user: 'KHRU', url: '' },
  { user: "People's Liberation Army (PLA) Strategic Support Force", url: '' },
  { user: 'Korea Advanced Institute of Science and Technology (KAIST)', url: '' },
  { user: 'NASA Ames Research Center', url: '' },
  { user: 'Maxar Technologies', url: '' },
  { user: 'MAXARI', url: '' },
  { user: 'Institute of Space Technology (IST), Space & Upper Atmosphere Research Commission (SUPARCO)', url: '' },
  { user: 'ZHKO', url: '' },
  { user: 'Smart Satellite Technology', url: '' },
  { user: 'Shanghai Qingshen Technology Development Co. Ltd.', url: '' },
  { user: "People's Republic of China", url: '' },
  { user: 'SPUTNIX', url: '' },
  { user: 'Twenty First Century Aerospace Technology Co., Ltd. (21AT)', url: '' },
  { user: 'YUNCH/NANXI', url: '' },
  { user: 'XINGH/TLCJ', url: '' },
  { user: 'Beijing Zero Gravity Space Technology Co., Ltd.', url: '' },
  { user: 'ESA/JAXA', url: '' },
  { user: 'JIGU', url: '' },
  { user: 'Mumei Xingkong Keji', url: '' },
  { user: 'XIDO', url: '' },
  { user: 'Chinese Academy of Sciences', url: '' },
  { user: 'KINEIS', url: '' },
  { user: 'CASC/CNES', url: '' },
  { user: 'China National Space Administration (CNSA)', url: '' },
  { user: 'Japan Aerospace Exploration Agency (JAXA)', url: '' },
  { user: 'University of Washington', url: '' },
  { user: 'University of Kansas', url: '' },
  { user: 'TIS', url: '' },
  { user: 'JSC', url: '' },
  { user: 'NASA Ames Research Center / San Jose State University', url: '' },
  { user: 'UME', url: '' },
  { user: 'FFLY', url: '' },
  { user: 'UCB/NASA', url: '' },
  { user: 'ISTL', url: '' },
  { user: 'ORBMAT', url: '' },
  { user: 'PTS', url: '' },
  { user: 'UAZ', url: '' },
  { user: 'NGIS', url: '' },
  { user: 'YUANX', url: '' },
  { user: 'Space Norway HEOSAT', url: '' },
  { user: 'SPNOR/SFSSC', url: '' },
  { user: 'UNKUS', url: '' },
  { user: 'USYD', url: '' },
  { user: 'ARRAY', url: '' },
  { user: 'SATORO', url: '' },
  { user: 'C3S', url: '' },
  { user: 'UKSC', url: '' },
  { user: 'AVS', url: '' },
  { user: 'CREO', url: '' },
  { user: 'FOI', url: '' },
  { user: 'ARC/TERRAN', url: '' },
  { user: 'PSAS', url: '' },
  { user: 'AETH', url: '' },
  { user: 'USYD/UNSW', url: '' },
  { user: 'FRAUN', url: '' },
  { user: 'SENSAT/MONTP', url: '' },
  { user: 'LEMU', url: '' },
  { user: 'Sateliot', url: 'https://sateliot.space/' },
  { user: 'KOMI', url: '' },
  { user: 'UM5R', url: '' },
  { user: 'SMCRC', url: '' },
  { user: 'NSL', url: '' },
  { user: 'KUVA', url: '' },
  { user: 'SPIRE/MYRI', url: '' },
  { user: 'Spire Global', url: '' },
  { user: 'JTXZ', url: '' },
  { user: 'TZXK', url: '' },
  { user: 'Xiamen Tianwei Technology Co., Ltd.', url: '' },
  { user: 'IEI/IRSA', url: '' },
  { user: 'ZHYE', url: '' },
  { user: 'XGZD', url: '' },
  { user: 'TLCJ/ZZQY', url: '' },
  { user: 'ZHWK/JIG', url: '' },
  { user: 'ONEWEBE', url: 'https://www.oneweb.world/' },
  { user: 'MGUS', url: '' },
  { user: 'BGTU', url: '' },
  { user: 'NARFU', url: '' },
  { user: 'SPBGUT', url: '' },
  { user: 'S2086/SITRO', url: '' },
  { user: 'SARPT', url: '' },
  { user: 'OMID/ISRC', url: '' },
  { user: 'MTUSI', url: '' },
  { user: 'AMGU/HARB', url: '' },
  { user: 'TUSUR', url: '' },
  { user: 'ZINGSA/YUZGU', url: '' },
  { user: 'MIREA', url: '' },
  { user: 'YUZGU', url: '' },
  { user: 'ESPRW', url: '' },
  { user: 'CGSTL/ISCAS', url: '' },
  { user: 'ZHWK/ZXHK', url: '' },
  { user: 'TLCJ/JUNT', url: '' },
  { user: 'SQU/STARV', url: '' },
  { user: 'CASTIX', url: '' },
  { user: 'XXYW', url: '' },
  { user: 'Shanghai Spacecom Satellite Technology (SSST)', url: '' },
  { user: 'European Space Agency (ESA)', url: '' },
  { user: 'ArkEdge Space Inc.', url: '' },
  { user: 'KANSAI', url: '' },
  { user: 'KYO', url: '' },
  { user: 'TASA/TOK', url: '' },
  { user: 'PIESAT Information Technology Co., Ltd.', url: '' },
  { user: 'United States Space Force', url: '' },
  { user: 'Guodian Gaoke', url: '' },
  { user: 'Defense Acquisition Program Administration (DAPA)', url: '' },
  { user: 'HawkEye 360', url: '' },
  { user: 'BRONC', url: '' },
  { user: 'GITAI', url: '' },
  { user: 'LASAR', url: '' },
  { user: 'Tomorrow.io', url: '' },
  { user: 'ONDO Space', url: '' },
  { user: 'Society for Out-of-Frame Education', url: '' },
  { user: 'ONDO Space LLC', url: '' },
  { user: 'Xplore Inc.', url: '' },
  { user: 'Spacecoin', url: '' },
  { user: 'Centre for Studies and Research of Djibouti (CERD)', url: '' },
  { user: 'ThinkOrbital Inc.', url: '' },
  { user: 'Unknown', url: '' },
  { user: 'Synspective Inc.', url: '' },
  { user: 'Roscosmos', url: '' },
  { user: 'Astranis', url: '' },
  { user: 'Anuvu', url: '' },
  { user: 'Orbits Corporation', url: '' },
  { user: 'Space42', url: '' },
  { user: 'China Aerospace Science and Technology Corporation (CASC)', url: '' },
  { user: 'Centispace', url: '' },
  { user: 'Beijing Future Navigation Technology Co., Ltd.', url: '' },
  { user: 'CentiSpace', url: '' },
  { user: 'NANAV/ABSEN', url: '' },
  { user: 'SPINV/ESA', url: '' },
  { user: 'HCT/MBRSC', url: '' },
  { user: 'DIGAN/ORBAS', url: '' },
  { user: 'NOVI', url: '' },
  { user: 'PAU', url: '' },
  { user: 'VZCR/VZLU', url: '' },
  { user: 'ALMAG/XDLINX', url: '' },
  { user: 'TRLS', url: '' },
  { user: 'TASA/PYRAS', url: '' },
  { user: 'ARKE', url: '' },
  { user: 'UZMA/URUGUS', url: '' },
  { user: 'FOSSA', url: '' },
  { user: 'ORORA', url: '' },
  { user: 'UAEU', url: '' },
  { user: 'CNSTR', url: '' },
  { user: 'FERG', url: '' },
  { user: 'DRDC/UTIAS', url: '' },
  { user: 'UNKJ', url: '' },
  { user: 'MBS/REFLEX', url: '' },
  { user: 'VARDA', url: '' },
  { user: 'INVER', url: '' },
  { user: 'CRUNCH', url: '' },
  { user: 'PIXX', url: '' },
  { user: 'ASI/ARGOT', url: '' },
  { user: 'SP42', url: '' },
  { user: 'Firefly Aerospace', url: '' },
  { user: 'ispace', url: '' },
  { user: 'Blue Origin', url: '' },
  { user: 'SUPARCO', url: '' },
  { user: 'GalaxySpace', url: '' },
  { user: 'Hangzhou Dianzi University', url: '' },
  { user: 'Yunyao Aerospace', url: '' },
  { user: 'K-Space Aerospace Technology Co.', url: '' },
  { user: 'National Reconnaissance Office (NRO)', url: '' },
  { user: "People's Liberation Army Strategic Support Force (PLA SSF)", url: '' },
  { user: 'Indian Space Research Organisation (ISRO)', url: '' },
  { user: 'Hisdesat Servicios Estratégicos S.A.', url: '' },
  { user: 'Russian Ministry of Defence', url: '' },
  { user: 'Russian Federal Space Agency (ROSCOSMOS)', url: '' },
  { user: 'Kinéis', url: '' },
  { user: 'Rocket Lab', url: '' },
  { user: 'ZXW', url: '' },
  { user: 'PATIN', url: '' },
  { user: 'INTMA', url: '' },
  { user: 'EPICU', url: '' },
  { user: 'CIT/JPL', url: '' },
  { user: 'AFORGE', url: '' },
  { user: 'DGA/CNES', url: '' },
  { user: 'SWRI/GSFC', url: '' },
  { user: 'KTL', url: '' },
  { user: 'NUSHS', url: '' },
  { user: 'STCAL', url: '' },
  { user: 'TAU/ISA', url: '' },
  { user: 'ORBAS/LIFTE', url: '' },
  { user: 'BIUST', url: '' },
  { user: 'HEX20', url: '' },
  { user: 'ALBEDO', url: '' },
  { user: 'SATREC', url: '' },
  { user: 'MITRE', url: '' },
  { user: 'VESTGO/ADIG', url: '' },
  { user: 'BNSSA', url: '' },
  { user: 'USPACE', url: '' },
  { user: 'UNSW/DSTO', url: '' },
  { user: 'LATMOS', url: '' },
  { user: 'LUSO', url: '' },
  { user: 'HYDRA', url: '' },
  { user: 'HYDRA/ICH', url: '' },
  { user: 'CTYK/CUGW', url: '' },
  { user: 'CTYK/SUST', url: '' },
  { user: 'CTYK/NCHU', url: '' },
  { user: 'CTYK/ZHYE', url: '' },
  { user: 'CTYK/YOUD', url: '' },
  { user: 'LANDSP', url: '' },
  { user: 'DLR/JENAU', url: '' },
  { user: 'ALENSP', url: '' },
  { user: 'ACMEO', url: '' },
  { user: 'UND', url: '' },
  { user: 'TPA', url: '' },
  { user: 'UNHAN', url: '' },
  { user: 'WISEK', url: '' },
  { user: 'GALAX', url: '' },
  { user: 'XONA', url: '' },
  { user: 'SDA/YORKSS', url: '' },
  { user: 'GILM', url: '' },
  { user: 'COSMW', url: '' },
  { user: 'DUTH', url: '' },
  { user: 'SPFORG', url: '' },
  { user: 'HUBN/SPIREG', url: '' },
  { user: 'UCB/GSFC', url: '' },
  { user: 'HARRL3', url: '' },
  { user: 'HUBN/ENDUR', url: '' },
  { user: 'SPIRE/MCON', url: '' },
  { user: 'HYDRO', url: '' },
  { user: 'LOFT/EDA', url: '' },
  { user: 'HANCOM', url: '' },
  { user: 'FMI/FMV', url: '' },
  { user: 'ISA', url: '' },
  { user: 'SPIRE/LACU', url: '' },
  { user: 'TYVI/PICO', url: '' },
  { user: 'NASA/UIA', url: '' },
  { user: 'LARCN/STP', url: '' },
  { user: 'APL/NASA', url: '' },
  { user: 'DART', url: '' },
  { user: 'GEOSK', url: '' },
  { user: 'RATEKS', url: '' },
  { user: 'IRSA/IUST', url: '' },
  { user: 'HANGSH', url: '' },
  { user: 'XJRY', url: '' },
  { user: 'ISRO/JPL', url: '' },
];
